/* eslint-disable */
var baseApiUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseApiUrl = 'https://cherry-report-upload-api.geodemosolutions.com/public/'
 }
else {
  baseApiUrl = 'http://localhost/cherry-report-upload-api/public/'
}

export {
  baseApiUrl
}
